import * as React from "react"
import { PageProps, Link, graphql } from "gatsby"

import Blog from "../components/blog"
import Seo from "../components/seo"

type DataProps = {
  site: {
    buildTime: string
  }
}

const Absensikelas: React.FC<PageProps<DataProps>> = ({ data, path }) => (
  <Blog>
    <Seo title="Aplikasi Absensi kelas Sekolah" />
    <h1><strong><a href="/absensikelas/">Aplikasi Absensi</a></strong></h1>
    <div className="embed-responsive embed-responsive-16by9 rounded">
<iframe width="560" height="315" src="https://www.youtube.com/embed/T8Xzb6VnWNE" title="absensi sekolah"></iframe>
</div>
    <p>
Kebutuhan untuk absensi siswa di kelas menjadi semakin mudah dengan hadirnya aplikasi absensi ini, ini adalah fitur tambahan untuk kebutuhan aplikasi sekolah dan paket premium website sekolah.
    </p>
<div className="embed-responsive embed-responsive-16by9 rounded">
<iframe width="560" height="315" src="https://www.youtube.com/embed/i0jk2p77qQA" title="absensi sekolah"></iframe>
</div>
<p>Semakin mudah dengan dukungan APK android dalam bekerja untuk mobilitas pada aktivitas belajar mengajar</p>
<br/>    <Link to="/">Go back to the homepage</Link>
  </Blog>
)

export default Absensikelas

export const query = graphql`
  {
    site {
      buildTime(formatString: "YYYY-MM-DD hh:mm a z")
    }
  }
`
